export const SET_USER_IS_TABBING = 'SET_USER_IS_TABBING';
export const UNSET_USER_IS_TABBING = 'UNSET_USER_IS_TABBING';
export const EDITABLE_INPUT_FIELD_ACTIVE = 'EDITABLE_INPUT_FIELD_ACTIVE';
